export const API_URL = "https://forkify-api.herokuapp.com/api/v2/recipes/";
export const TIMEOUT_SECONDS = 10;
export const RESULTS_PER_PAGE = 10;
export const KEY = "45fbcdbb-2514-4501-9149-5e2b33b427bf";
export const MODAL_CLOSE_SECONDS = 3;
